import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-brand-navy" data-id="element-85" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-86" data-mp="9tbduvlsumhr">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-brand-gold bg-brand-cream p-3 text-left" data-id="element-87" data-mp="etfy8wptw1d9">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border-2 border-brand-navy bg-brand-gold" data-id="element-88" data-mp="jt2ap3xu1dl0">
            <ShieldCheckIcon size={24} className="text-brand-navy" data-id="element-89" data-mp="nskrbnimf2i1" />
          </span>
          <div data-id="element-90" data-mp="sm5hwuhvwu77">
            <p className="font-sub text-xs font-bold uppercase tracking-wide text-brand-muted" data-id="element-91" data-mp="slmc2c5idw9j">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-xl leading-tight sm:text-2xl" data-id="element-92" data-mp="12jjxyszwbgyz">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-93" data-mp="25rnfkppgw4oj">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el material no es adecuado para tu familia, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}